import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
//api
import { createFaq } from 'api/faqs';
//components
import Title from 'components/backoffice/texts/title';
import FaqForm from 'components/backoffice/forms/faqForm';

const CreateFaq = () => {
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const { setTitle } = useOutletContext()

  useEffect(() => {
    setTitle(t('createfaq'))
    return () => {
      setTitle('');
    };
  }, [])

  const onSubmit = async (values) => {
    const order = values.order;
    delete values.order;
    const sendValues = {
      order: order.value,
      ...values,
    };
    try {
      const { status } = await createFaq(sendValues);
      if (status === 200 || status === 201) {
        toast.success(t('creadocorrectamente'));
        navigate(-1);
      } else toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
    } catch (error) {
      console.error('Error en onCreate:', error);
    }
  };

  return (
    <div>
      <Title text={t('crear')} />
      <FaqForm onSubmit={onSubmit} faq={{}} />
    </div>
  );
};

export default CreateFaq;
